import { ReactComponent as Icon } from '../Input/trash-solid.svg';

import styles from './DeleteIcon.module.scss';

const DeleteIcon = ({ onDelete }: { onDelete: () => void }) => {
  return (
    <div title="Delete" className={styles.wrapper} onClick={onDelete}>
      <Icon className={styles.icon} />
    </div>
  );
};

export default DeleteIcon;
